import React from 'react'
import List from './List'
import { useContractPopById } from 'src/queries'

interface BodyProps {
  id: string
}

const Body: React.FC<BodyProps> = (props) => {
  const { id } = props
  const contract = useContractPopById(id)
  return (
    <List contract={contract} />
  )
}

export default Body
